<template>
  <div class="bread-crumb flex align-items-center">
    <span>当前位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <template v-for="(item, index) in routeList">
        <el-breadcrumb-item
          v-if="item.path"
          :key="index"
          :to="{
            path: item.path,
            query: Object.assign({ breadpath: 'breadpath' }, item.query),
          }"
          >{{ item.name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item v-else :key="index">{{
          item.name
        }}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "breadCrumbCas",
  props: ["routeList", "labelType"],
  data() {
    return {
      breadArray: [],
    };
  },
  created() {
    // eslint-disable-next-line vue/no-mutating-props
    this.routeList.splice(2);
    if (!this.routeList || this.routeList.length === 0) {
      // eslint-disable-next-line vue/no-mutating-props
      this.routeList = this.getSessionStorage();
    }
    if (!this.routeList.find((item) => item.path === this.$route.path)) {
      if (this.$route.params.id) {
        // eslint-disable-next-line vue/no-mutating-props
        this.routeList.push({
          path: this.$route.path,
          query: this.$route.query,
          name: `${this.changeNumToHan(this.$route.params.id)}级${
            this.labelType === "common"
              ? "通用"
              : this.labelType === "indexs"
              ? "索引"
              : "业务"
          }${this.labelType === "indexs" ? "" : "标签"}`,
        });
      }
    }
    this.setSessionStorage();
    this.setBreadArrayCas(this.routeList);
  },
  watch: {
    $route(newVal, oldValue) {
      if (!this.routeList.find((item) => item.path === this.$route.path)) {
        this.routeList.push({
          path: this.$route.path,
          query: this.$route.query,
          name: `${this.changeNumToHan(this.$route.params.id)}级${
            this.labelType === "common"
              ? "通用"
              : this.labelType === "indexs"
              ? "索引"
              : "业务"
          }${this.labelType === "indexs" ? "" : "标签"}`,
        });
      } else {
        const index = this.routeList.findIndex(
          (item) => item.path === this.$route.path
        );
        // eslint-disable-next-line vue/no-mutating-props
        this.routeList.splice(index + 1);
      }
      this.setSessionStorage();
      if (this.labelType === "indexs") {
        this.setBreadArrayIndex(this.routeList);
        return;
      }
      this.setBreadArrayCas(this.routeList);
    },
  },
  methods: {
    ...mapMutations(["setBreadArrayCas", "setBreadArrayIndex"]),
    setSessionStorage() {
      try {
        const sessionStorageBreadBk = JSON.parse(
          localStorage.getItem(`labelBread${this.labelType}`)
        );
        let sessionStorageBread = sessionStorageBreadBk;
        if (!sessionStorageBreadBk) {
          sessionStorageBread = { custom: {}, common: {} };
        }
        const key = `${this.$route?.query?.groupId || "-1"}${
          this.$route?.params?.id || "group"
        }`;
        if (sessionStorageBread[key]) {
          sessionStorageBread[key] = this.routeList;
        } else {
          sessionStorageBread = {
            ...sessionStorageBread,
            [key]: this.routeList,
          };
        }
        localStorage.setItem(
          `labelBread${this.labelType}`,
          JSON.stringify(sessionStorageBread)
        );
      } catch (e) {
        console.log(e);
      }
    },
    getSessionStorage() {
      try {
        const sessionStorageBreadBk = JSON.parse(
          localStorage.getItem(`labelBread${this.labelType}`)
        );
        let sessionStorageBread = sessionStorageBreadBk;
        const key = `${this.$route?.query?.groupId || "-1"}${
          this.$route?.params?.id || "group"
        }`;
        if (!sessionStorageBreadBk[key]) {
          let routePath = "/customLabel/group";
          if (this.labelType === "indexs") {
            routePath = "/indexManage/group";
          } else if (this.labelType === "common") {
            routePath = "/commonLabel/group";
          }
          history.replace({ path: routePath });
          return "";
        }
        return sessionStorageBread[+key];
      } catch (e) {
        console.log(e);
      }
    },
    changeNumToHan(num) {
      var arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var arr2 = [
        "",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
      ];
      if (!num || isNaN(num)) return "零";
      var english = num.toString().split("");
      var result = "";
      for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i; // 倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
      }
      result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
      result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
      result = result.replace(/零+$/, ""); // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, "十");
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.bread-crumb {
  color: rgba(124, 132, 149, 1);
  font-size: 13px;
  margin-bottom: 20px;
  :deep(.el-breadcrumb__item) {
    font-size: 13px;
    color: rgba(124, 132, 149, 1);
    .is-link {
      font-weight: normal;
      color: rgba(124, 132, 149, 1);
    }
    &:last-child {
      .is-link {
        color: rgba(76, 84, 99, 1);
      }
    }
  }
}
</style>
